import { CopyText } from '../i18n/Language';
import { Component } from 'react';
import { Link, useLanguage } from '../i18n/Language';

function ErrorFallback({ onReset }) {
  const { t } = useLanguage();
  return <div className="min-h-screen flex items-center justify-center px-6"><div className="text-center max-w-md"><h1 className="text-2xl font-bold text-gray-900 mb-3"><CopyText source={'Something went wrong'} /></h1><p className="text-gray-600 mb-8"><CopyText source={'An unexpected error occurred. Please try refreshing the page.'} /></p><Link to="/" onClick={onReset} className="inline-flex items-center gap-2 px-6 py-3 bg-black text-white rounded-full font-medium hover:bg-gray-800 transition-colors"><CopyText source={'Back to Home'} /></Link></div></div>;
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback onReset={() => this.setState({ hasError: false })} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
